// This file is generated by a script and should not be modified directly.
const markdown: string =
  "Latitude of the GPS coordinate of the search area.\n\nThe search will cover the entire France if not specified.\n\nThis field should be mandatory when used with the longitude field.\n"
export default markdown
